<template>
  <div class="page">
    <SiteHero
      pageTitle="Schedule"
      pageDescription="Schedule of classes"
    />
  
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div id="buenaPark" class="location-block scroll-mt-32">
            <LocationTitle title="BUENA PARK SCHEDULE" />
            <ScheduleCategory 
              title="BUENA PARK CLASSES"
              id="buenaParkSchedule"
              scheduleType="uncategorized"
              location="buenaPark"
            />
          </div>

          <div id="irvine" class="location-block scroll-mt-32">
            <LocationTitle title="IRVINE SCHEDULE" />
            <ScheduleCategory 
              title="IRVINE - MENS CLASSES"
              id="irvineMensSchedule"
              scheduleType="mens"
              location="irvine"
            />
            <ScheduleCategory 
              title="IRVINE - WOMENS CLASSES"
              id="irvineWomensSchedule"
              scheduleType="womens"
              location="irvine"
            />
            <ScheduleCategory 
              title="IRVINE - KIDS CLASSES"
              id="irvineKidsSchedule"
              scheduleType="kids"
              location="irvine"
            />
          </div>
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>
    
<script>
import LocationTitle from '../components/Schedule/LocationTitle.vue'
import ScheduleCategory from '../components/Schedule/ScheduleCategory.vue'
import SiteFooter from '../components/Footer/SiteFooter.vue'
import SiteHero from '../components/Hero/SiteHero.vue'
import '../assets/styles/page.css'
  
export default {
  name: 'SchedulePage',
  components: {
    LocationTitle,
    ScheduleCategory,
    SiteFooter,
    SiteHero,
  }
}
</script>

<style scoped>
.schedule-table {
  @apply bg-white;
}

.schedule-table td:empty {
  background-color: rgb(17, 17, 17);
}

.location-block {
  @apply bg-gray-50 p-8 rounded-lg shadow-sm;
}
</style>
